import React from "react";
import { business } from "../data";
import { IoLogoWhatsapp, IoLogoFacebook, IoLogoYoutube } from "react-icons/io";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Contact = () => {
    return (
        <section className='section pt-32 min-h-screen bg-gray-50'>
            <div className='container mx-auto px-4'>
                
                {/* Back Button */}
                <Link to="/" className='inline-flex items-center text-blue-600 hover:text-blue-800 transition mb-8 font-medium'>
                    ← Back to Home
                </Link>

                {/* Header */}
                <div className='text-center mb-12'>
                    <h1 className='text-4xl md:text-5xl font-bold text-blue-900 mb-4'>Contact Kohla News</h1>
                    <p className='text-gray-600 text-lg max-w-2xl mx-auto'>
                        Have a news tip, story idea, or question? We'd love to hear from you!
                    </p>
                </div>

                {/* Main Grid */}
                <div className='grid lg:grid-cols-5 gap-8 max-w-7xl mx-auto'>
                    
                    {/* Left Column - Contact Info (3 columns) */}
                    <div className='lg:col-span-3 space-y-6'>
                        
                        {/* Business Info Card */}
                        <div className='bg-white rounded-2xl shadow-lg p-8'>
                            <h2 className='text-2xl font-semibold text-blue-900 mb-6 flex items-center'>
                                <span className='w-10 h-1 bg-yellow-500 rounded-full mr-3'></span>
                                Get in Touch
                            </h2>
                            
                            <div className='grid md:grid-cols-2 gap-6'>
                                {/* Phone */}
                                <div className='flex items-start gap-4 p-4 bg-gray-50 rounded-xl hover:shadow-md transition'>
                                    <div className='w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0'>
                                        <FaPhone className='text-green-600 text-xl' />
                                    </div>
                                    <div>
                                        <h3 className='font-semibold text-gray-700'>Call Us</h3>
                                        <a href="tel:923000000000" className='text-blue-600 hover:underline text-sm mt-1 block'>
                                            {business.phone}
                                        </a>
                                    </div>
                                </div>

                                {/* WhatsApp */}
                                <div className='flex items-start gap-4 p-4 bg-gray-50 rounded-xl hover:shadow-md transition'>
                                    <div className='w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0'>
                                        <FaPhone className='text-green-600 text-xl' />
                                    </div>
                                    <div>
                                        <h3 className='font-semibold text-gray-700'>WhatsApp</h3>
                                        <a href={business.whatsappLink} target='_blank' rel='noreferrer' 
                                            className='text-blue-600 hover:underline text-sm mt-1 block'>
                                            {business.whatsapp}
                                        </a>
                                    </div>
                                </div>

                                {/* Email */}
                                <div className='flex items-start gap-4 p-4 bg-gray-50 rounded-xl hover:shadow-md transition'>
                                    <div className='w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0'>
                                        <FaEnvelope className='text-blue-600 text-xl' />
                                    </div>
                                    <div>
                                        <h3 className='font-semibold text-gray-700'>Email</h3>
                                        <a href={`mailto:${business.email}`} 
                                            className='text-blue-600 hover:underline text-sm mt-1 block'>
                                            {business.email}
                                        </a>
                                    </div>
                                </div>

                                {/* Address */}
                                <div className='flex items-start gap-4 p-4 bg-gray-50 rounded-xl hover:shadow-md transition'>
                                    <div className='w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0'>
                                        <FaMapMarkerAlt className='text-blue-600 text-xl' />
                                    </div>
                                    <div>
                                        <h3 className='font-semibold text-gray-700'>Address</h3>
                                        <p className='text-gray-500 text-sm mt-1'>{business.address}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* News Categories Grid - NEW */}
                        <div className='bg-white rounded-2xl shadow-lg p-8'>
                            <h2 className='text-2xl font-semibold text-blue-900 mb-6 flex items-center'>
                                <span className='w-10 h-1 bg-yellow-500 rounded-full mr-3'></span>
                                Our Coverage Areas
                            </h2>
                            <div className='grid grid-cols-2 md:grid-cols-3 gap-3'>
                                <div className='bg-red-100 text-red-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🔴 Breaking News</div>
                                <div className='bg-blue-100 text-blue-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🏘️ Okara Local</div>
                                <div className='bg-green-100 text-green-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🏛️ Punjab News</div>
                                <div className='bg-teal-100 text-teal-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🇵🇰 Pakistan News</div>
                                <div className='bg-indigo-100 text-indigo-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🌍 International</div>
                                <div className='bg-red-100 text-red-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🗳️ Politics</div>
                                <div className='bg-green-100 text-green-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🌾 Agriculture</div>
                                <div className='bg-blue-100 text-blue-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🏏 Sports</div>
                                <div className='bg-yellow-100 text-yellow-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🌤️ Weather</div>
                                <div className='bg-purple-100 text-purple-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>💼 Business</div>
                                <div className='bg-orange-100 text-orange-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>📚 Education</div>
                                <div className='bg-pink-100 text-pink-600 px-3 py-2 rounded-lg text-sm font-medium text-center'>🏥 Health</div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Map & Social (2 columns) */}
                    <div className='lg:col-span-2 space-y-6'>
                        
                        {/* Google Map Card */}
                        <div className='bg-white rounded-2xl shadow-lg p-6 sticky top-32'>
                            <h2 className='text-2xl font-semibold text-blue-900 mb-4 flex items-center'>
                                <span className='w-10 h-1 bg-yellow-500 rounded-full mr-3'></span>
                                Find Us
                            </h2>
                            
                            <div className='rounded-xl overflow-hidden shadow-md h-72 lg:h-80'>
                                <iframe
                                    title="Kohla News Location"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d109166.87629315608!2d73.38068613666395!3d30.808136473350375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3920ae2c9b4b6b6b%3A0x7f4c5c5c5c5c5c5c!2sOkara%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1700000000000"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    className='w-full h-full'
                                ></iframe>
                            </div>

                            {/* Map Buttons */}
                            <div className='mt-4 space-y-3'>
                                <a 
                                    href={business.mapLink} 
                                    target='_blank' 
                                    rel='noreferrer'
                                    className='block w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition text-center font-semibold'
                                >
                                    📍 Open in Google Maps
                                </a>
                                
                                <a 
                                    href={business.whatsappLink} 
                                    target='_blank' 
                                    rel='noreferrer'
                                    className='block w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl transition text-center font-semibold'
                                >
                                    💬 Chat on WhatsApp
                                </a>
                            </div>

                            {/* Social Links */}
                            <div className='mt-6 pt-6 border-t border-gray-200'>
                                <h3 className='font-semibold text-gray-700 mb-3 text-center'>Follow Kohla News</h3>
                                <div className='flex justify-center gap-4 flex-wrap'>
                                    <a 
                                        href={business.youtube} 
                                        target='_blank' 
                                        rel='noreferrer'
                                        className='w-14 h-14 bg-gray-100 hover:bg-red-600 text-gray-600 hover:text-white text-2xl rounded-full flex items-center justify-center transition duration-300 hover:shadow-lg'
                                    >
                                        <IoLogoYoutube />
                                    </a>
                                    <a 
                                        href={business.facebook} 
                                        target='_blank' 
                                        rel='noreferrer'
                                        className='w-14 h-14 bg-gray-100 hover:bg-blue-600 text-gray-600 hover:text-white text-2xl rounded-full flex items-center justify-center transition duration-300 hover:shadow-lg'
                                    >
                                        <IoLogoFacebook />
                                    </a>
                                    <a 
                                        href={business.tiktok} 
                                        target='_blank' 
                                        rel='noreferrer'
                                        className='w-14 h-14 bg-gray-100 hover:bg-black text-gray-600 hover:text-white text-2xl rounded-full flex items-center justify-center transition duration-300 hover:shadow-lg'
                                    >
                                        🎵
                                    </a>
                                    <a 
                                        href={business.whatsappLink} 
                                        target='_blank' 
                                        rel='noreferrer'
                                        className='w-14 h-14 bg-gray-100 hover:bg-green-500 text-gray-600 hover:text-white text-2xl rounded-full flex items-center justify-center transition duration-300 hover:shadow-lg'
                                    >
                                        <IoLogoWhatsapp />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Contact;